import { Project } from '@material-bank/projects-api';
import { getAnalyticsItemType } from '@mb/lib';
import { getAnalyticsItemCategoriesByTaxonomy } from './getAnalyticsItemCategoriesByTaxonomy';
import { ProductSearchMaterial } from '../../../../pages/ProductSearch/types';

export const mapMaterialsForAnalytics = (
  data: ProductSearchMaterial[] = [],
  currentColor: string,
  itemListId: string,
  itemListName: string,
  eventLocation: string | null = null,
  project: Project | null = null,
) => {
  const configLang =
    typeof ENVIRONMENT_REGION !== 'undefined' ? ENVIRONMENT_REGION : null;
  const currency = configLang === 'EU' ? 'EUR' : 'USD';

  const gaType = data?.map((item, index) => {
    const colorway = item.colorVariants?.items?.find(
      (color) => color.image_url === item.thumbnailImageUrl?.split('?')?.[0],
    );
    let itemColor = null;
    if (colorway != null) {
      itemColor = colorway?.exact_color;
    }
    const finishesColor = item?.configData?.color;

    const itemId = item.configurations?.[0]?.items?.[0]?.sku || item.sku;

    const finalObj: any = {
      item_id: itemId,
      item_name: item.name,
      item_brand: item.manufacturer,
      item_type: getAnalyticsItemType(item),
      ...getAnalyticsItemCategoriesByTaxonomy(item.taxonomy ?? []),
      item_category4: item.industrySector?.join(', ') || '',
      // Provide the bag project type on add_to_cart events, current project type label otherwise
      item_category5: project?.type?.label || '',
      item_manufacturer_sample_id: item.manufacturerSampleId,
      family_sku: item.familySku,
      index: item.gridIndex || index + 1,
      price: 0,
      quantity: 1,
      item_list_id: itemListId,
      item_list_name: itemListName,
      item_variant: finishesColor || currentColor || itemColor || '',
    };

    if (item.associatedItem != null) {
      finalObj['associated_item'] = item.associatedItem || '';
    }

    return finalObj;
  });

  return { gaType, currency };
};
